export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_OPTIONS = [5, 10, 15, 20, 25, 50, 100];
